{
  "NAME": "DirectoryModal",
  "AddDirectoryTitle": "Aggiungi elenco",
  "ModifyDirectoryTitle": "Modificare la directory",
  "TelServerFormLabel": "Server telefonico",
  "PartitionFormLabel": "Partizione",
  "TelNumberFormLabel": "Numero di telefono",
  "DescriptionFormLabel": "Descrizione",
  "DirectoryAddModify_UnknownOrDeleted": "[Sconosciuto o cancellato]",
  "DirectoryAddModify_ServerErrorTitle": "Errori di convalida",
  "DirectoryAddModify_ValidationWarning": "Assicurarsi che tutti i campi siano compilati correttamente",
  "DirectoryAddModify_ButtonHelpLabel": "Aiuto?",
  "DirectoryAddModify_ButtonSubmitLabel": "Risparmiare",
  "DirectoryAddModify_ButtonCancelLabel": "Annullamento",
  "DirectoryAddModify_PromptMessage": "Siete sicuri di voler chiudere questa finestra? Tutte le configurazioni modificate andranno perse una volta chiuse.",
  "DirectoryAddModify_PromptConfirm": "Sì",
  "DirectoryAddModify_PromptCancel": "Annullamento",
  "TelNumberFormLabel_Validation_Error": "È richiesto il numero di telefono",
  "DescriptionFormLabel_Validation_Error": "La descrizione è necessaria",
  "DirectoryAddModify_TabsDetails": "Dettagli"
}